import "zod/compile";
import { z } from "zod";

export const JsonWireValueSchema: z.ZodType<z.JSONType, z.JSONType> = z.lazy(
  () =>
    z.union([
      z.string(),
      z.number(),
      z.boolean(),
      z.null(),
      z.array(JsonWireValueSchema),
      z.record(z.string(), JsonWireValueSchema),
    ]),
);
